import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {IDepartment, IDepartmentRequest, IListDepartmentsRequest} from "../models/departement";
import {DepartementService} from "./departement.service";

@Injectable({
  providedIn: 'root'
})
export class DepartementStoreService {

  constructor(
    private departementService : DepartementService
  ) {
    this.listDepartements();
  }

  private _departements$ = new BehaviorSubject<IDepartment[]>([]);
  public departements$ = this._departements$.asObservable();

  listRequest : IListDepartmentsRequest = {
    pageNumber: 0,
    pageSize: 10
  }

  listDepartements(request = this.listRequest){
    this.departementService.listDepartements(request).subscribe(response => {
      this._departements$.next(response.data)
    })
  }

  addDepartement(request: IDepartmentRequest){
    this.departementService.addDepartement(request)
      .subscribe(response => {
        this.listDepartements();
      })
  }

  updateDepartement(request: IDepartmentRequest){
    this.departementService.updateDepartement(request)
      .subscribe(response => {
        this.listDepartements();
      })
  }

  deleteDepartement(id:string){
    this.departementService.deleteDepartement(id)
      .subscribe(response => {
        this.listDepartements();
      })
  }
}
